export default __webpack_public_path__ + "static/media/BM_H_White.c573635c.svg";